import { HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { missionPage } from '../domain/mission-page';
import { MissionService } from '../services/mission.service';
import { PlayerSessionService } from '../services/player-session.service';

// Pages /missions/:missionId/* : le joueur doit avoir le jeton de la mission et
// arriver sur l'ecran qui correspond a son statut (TD-005), route data `page`.
// Sans `page`, la route redirige toujours vers l'ecran du statut.
export const missionGuard: CanActivateFn = async (route) => {
  const router = inject(Router);
  const missionId = Number(route.paramMap.get('missionId'));

  if (!Number.isInteger(missionId) || missionId <= 0) {
    return router.createUrlTree(['/not-found']);
  }
  if (!inject(PlayerSessionService).tokenFor(missionId)) {
    return router.createUrlTree(['/not-authorized']);
  }

  try {
    const mission = await inject(MissionService).getMission(missionId);
    const page = missionPage(mission);
    if (page === null) {
      return router.createUrlTree(['/not-authorized']);
    }
    if (page === 'victory') {
      return router.createUrlTree(['/operations', mission.operationPublicId, 'victory']);
    }
    return page === route.data['page']
      ? true
      : router.createUrlTree(['/missions', missionId, page]);
  } catch (error) {
    if (error instanceof HttpErrorResponse && error.status === 401) {
      return router.createUrlTree(['/not-authorized']);
    }
    if (error instanceof HttpErrorResponse && error.status === 404) {
      return router.createUrlTree(['/not-found']);
    }
    // Reseau ou API indisponible : la page affiche elle-meme l'erreur.
    return route.data['page'] ? true : router.createUrlTree(['/']);
  }
};
